import { useCallback } from 'react';
import type { FormatDateOption } from '../utils/date';
import { formatDateWithoutTimeZone, formatDateWithTimeZone } from '../utils/date';
import useDateLocale from './useDateLocale';
import useMarketTimeZone from './useMarketTimeZone';

interface UseFormatDate {
  formatDate: (date: Date, formatOption: FormatDateOption) => string;
}

const useFormatDate = (): UseFormatDate => {
  const locale = useDateLocale();
  const timeZone = useMarketTimeZone();

  const formatDate = useCallback(
    (date: Date, formatOption: FormatDateOption) => {
      if (timeZone) {
        return formatDateWithTimeZone(date, formatOption, timeZone, locale);
      }
      return formatDateWithoutTimeZone(date, formatOption, locale);
    },
    [locale, timeZone],
  );

  return { formatDate };
};

export default useFormatDate;
